
import { Mapper } from "../../../../base/utils/mapper";
import { ListPainScalePhysiotherapyModel } from "../../../../domain/models/consult/list-pain-scale-physiotherapy.model";
import { ListPainScalePhysiotherapyEntity } from "../entities/list-pain-scale-physiotherapy.entity";
export class ListPainScalePhysiotherapyImplementationRepositoryMapper extends Mapper<ListPainScalePhysiotherapyEntity, ListPainScalePhysiotherapyModel>{
            mapFrom(param:  ListPainScalePhysiotherapyEntity):  ListPainScalePhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  ListPainScalePhysiotherapyModel):  ListPainScalePhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }